/** Installing is optional. Updates wait for an explicit safe moment instead of reloading a running take. */
export async function registerOfflineApp(
  onUpdate?: (activate: () => void) => void,
): Promise<ServiceWorkerRegistration | null> {
  if (
    !("serviceWorker" in navigator) ||
    !window.isSecureContext ||
    import.meta.env.DEV
  )
    return null;
  try {
    const registration = await navigator.serviceWorker.register(
      `${import.meta.env.BASE_URL}service-worker.js`,
    );
    const offer = () => {
      if (registration.waiting)
        onUpdate?.(() =>
          registration.waiting?.postMessage({ type: "ACTIVATE_UPDATE" }),
        );
    };
    offer();
    registration.addEventListener("updatefound", () =>
      registration.installing?.addEventListener("statechange", () => {
        if (navigator.serviceWorker.controller) offer();
      }),
    );
    return registration;
  } catch {
    return null;
  }
}
